import { render, staticRenderFns } from "./EduQueryItem.vue?vue&type=template&id=5400aff6&scoped=true"
import script from "./EduQueryItem.vue?vue&type=script&lang=js"
export * from "./EduQueryItem.vue?vue&type=script&lang=js"
import style0 from "./EduQueryItem.vue?vue&type=style&index=0&id=5400aff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400aff6",
  null
  
)

export default component.exports